import { useSelector } from "react-redux";
import React from "react";
import xls from "xlsx";
import { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import { Modal } from "react-bootstrap";
import moment from "moment";
import * as fs from "fs";
import { uploadTransaction } from "../../stores/services/beta-transaction.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import { env } from "../../env";
import { numberWithCommas } from "../../utils/customFunction";
let csvToJson = require("convert-csv-to-json");
const csv = require("csvtojson/v2");

let xlsxToJson = require("convert-excel-to-json");

const LegacySecuritiesUploader = () => {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const fileKeysBMP = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValue",
        "Price",
        "SystemExecutionDate"
    ]
    const fileKeysCP = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValue",
        "Price",
        "SystemExecutionDate"
    ]
    const fileKeysLP = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValue",
        "Price",
        "SystemExecutionDate"
    ]
    const fileKeysPIBS = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValuePerUnit",
        "Price",
        "SystemExecutionDate",
        "Yield",
        "CouponPayment/Year",
        "NoofCoupons",
        "FaceValue/Unit",
        "KiborRateBenchmark",
        "KiborRate",
        "SpreadRate"
    ]
    const fileKeysTDR = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValue",
        "Price",
        "SystemExecutionDate"
    ]
    const fileKeysTBS = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValuePerUnit",
        "Price",
        "SystemExecutionDate",
        "Yield"
    ]
    const fileKeysCOI = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValue",
        "Price",
        "SystemExecutionDate"
    ]
    const fileKeysTFC = [
        "SecurityType",
        "Symbol",
        "Name",
        "IssueDate",
        "MaturityDate",
        "FaceValue",
        "Price",
        "SystemExecutionDate",
        "CouponPayment/Year",
        "NoofCoupons",
        "FaceValue/Unit",
        "KiborRateBenchmark",
        "KiborRate",
        "SpreadRate"
    ];
    const fileKeysSC = [
        "Security Type",
        "Symbol",
        "Name",
        "Issue Date",
        "Maturity Date",
        "Face Value",
        "Price",
        "System Execution Date",
        "Coupon Payment/Year",
        "No of Coupons",
        "Face Value/Unit",
        "Kibor Rate Benchmark",
        "Kibor Rate",
        "Spread Rate"
    ];

    const downloadSampleArr = [
        { "label": "Bai Mujjal Placement", "path": "Bai_Mujjal_Placement.xlsx" },
        { "label": "Commercial Papers", "path": "Commercial_Papers.xlsx" },
        { "label": "Letter of Placement", "path": "Letter_of_Placement.xlsx" },
        { "label": "PIB Security", "path": "PIB_Security.xlsx " },
        { "label": "Term Deposit Receipts", "path": "Term_Deposit_Receipts.xlsx" },
        { "label": "Treasury Bill Security", "path": "Treasury_Bill_Security.xlsx" },
        { "label": "Certificate of Investment", "path": "Certificate_of_Investment.xlsx" },
        { "label": "Term Finance Certificate", "path": "Term_Finance_Certificates.xlsx" },
        { "label": "Sukuk Certificate", "path": "Sukuk_Certificates.xlsx" },

    ];

    const requiredArrBCTTC = [
        "SecurityType",
        "Symbol",
        "Name",
        "SystemExecutionDate",
    ]

    const requiredArrPTCS = [
        "SecurityType",
        "Symbol",
        "Name",
        "SystemExecutionDate",
        "CouponPayment/Year",
        "FaceValue/Unit",
        "KiborRate",
        "SpreadRate",
        "NoofCoupons",
    ]

    const validSecurityTypes = [
        "pib",
        "tbill",
        "sukuk",
        "tfc",
        "cp",
        "tdr",
        "cdr",
        "lop",
        "bai mujjal placement",
    ]

    const history = useHistory();
    const [errorBoolean, setErrorBoolean] = useState(false);
    const amcCode = sessionStorage.getItem("amc_code") || "";
    const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
    const [loading, setLoading] = useState(false);
    const [fileData, setfileData] = useState<any>([]);
    const [fileDataCount, setFileDataCount] = useState(0);
    const myRef1 = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState("");
    const [fileError, setFileError] = useState("");
    const [file, setFile] = useState<any>();
    const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
    const email = sessionStorage.getItem("email") || "";
    const [errorInFile, setErrorInFile] = useState(false)
    const [loadingFileUpload, setLoadingFileUpload] = useState(false)

    const upload = async (e: any) => {
        if (e?.target.files[0] && e.target.value) {
            setFileError("");
            setfileData(null);
            let file = e?.target.files[0];

            let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
            if (type === "xlsx" || type === "csv") {
                setFile(file);
                setFileName(file?.name);
                //start

                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target?.result;
                    const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data: any = xls.utils.sheet_to_json(ws, {
                        header: 2,
                        raw: false,
                        defval: "",
                        dateNF: "YYYY-MM-DD",
                    });
                    // if file is empty 
                    if (data?.length === 0) {
                        toast.error("File Should not be empty")
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }


                    const uploadedHeaders = Object.keys(data[0])?.filter((ele) => !ele?.includes("__EMPTY")).map(item => item.trim());
                    const fileKeysList = [
                        fileKeysBMP, fileKeysCP, fileKeysLP, fileKeysPIBS, fileKeysTDR,
                        fileKeysTBS, fileKeysCOI, fileKeysTFC, fileKeysSC
                    ]; // created singular array for all keyheader arrays


                    const headersMatch = fileKeysList.some(keys => {
                        if (keys?.length > uploadedHeaders?.length) {
                            return keys.every(header => uploadedHeaders.includes(header))
                        }
                        else {
                            return uploadedHeaders.every(header => keys.includes(header))
                        }
                        // here checking it the file matched every header key of any sample file header key
                    });

                    if (!headersMatch) {
                        toast.error("Uploaded file headers do not match the expected format.");
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }

                    if (data?.some((ele) => ele?.SecurityType?.trim() == "")) {
                        toast.error("Security Type Should not be Empty");
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }

                    if (data?.some((ele) =>
                        !validSecurityTypes?.includes(ele?.SecurityType?.trim()?.toLowerCase())
                    )
                    ) {
                        const indexOfErr = data?.findIndex((item) => !validSecurityTypes?.includes(item?.SecurityType?.trim()?.toLowerCase()))
                        toast.error(`Invalid Security type at row ${indexOfErr + 2}`);
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }


                    const checkRequiredFields = (data, requiredFields) => {
                        return data.some(row => {
                            return requiredFields.some(field => {
                                const value = row[field.trim()]?.toString().trim(); // get trim valu
                                return !value; // true if valu is emoty
                            });
                        });
                    };


                    const hasEmptyFields = data.some(ele =>
                        ele.SecurityType?.trim()?.toLowerCase() === "pib" ||
                        ele.SecurityType?.trim()?.toLowerCase() === "tfc" ||
                        ele.SecurityType?.trim()?.toLowerCase() === "sukuk"
                    ) ? checkRequiredFields(data, requiredArrPTCS) :
                        checkRequiredFields(data, requiredArrBCTTC);

                    if (hasEmptyFields) {
                        setErrorInFile(true);
                    } else {
                        setErrorInFile(false);
                    }


                    if (data.length > 0) {
                        // filter those keys which has ___Empty 
                        const filteredData = data.map(obj => {
                            return Object.fromEntries(
                                Object.entries(obj).filter(([key]) => !key.startsWith('__EMPTY'))
                            );
                        });
                        setfileData(filteredData);
                        setFileDataCount(data.length);
                    }

                };
                if (rABS) reader.readAsBinaryString(file);
                else reader.readAsArrayBuffer(file);
                // end 2
            } else {
                toast.error("Please Upload Correct Format of File");
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
            }
            // removing value so that user can upload same file again
            e.target.value = ""
        }

    };

    const renderTable = () => {
        return fileData?.map((item: any, index: number) => {
            return (
                <tr key={index}>
                    {Object.entries(item).map(([key, value]: [string, any]) => {
                        let isHighlighted = false;

                        if (
                            (item?.SecurityType?.trim()?.toLowerCase() === "sukuk" ||
                                item?.SecurityType?.trim()?.toLowerCase() === "tfc" ||
                                item?.SecurityType?.trim()?.toLowerCase() === "pib")
                            &&
                            requiredArrPTCS?.includes(key) && value?.trim() === ""
                        ) {
                            isHighlighted = true;
                        } else if (requiredArrBCTTC?.includes(key) && value?.trim() === "") {
                            isHighlighted = true;
                        }
                        return (
                            <td key={key}
                                style={{
                                    backgroundColor: isHighlighted ? "#8b0000" : "",
                                    border: "1px solid #525f7f"
                                }}
                            >
                                {typeof value === "number"
                                    ? numberWithCommas(value.toFixed(4))
                                    : value}
                            </td>
                        )
                    })}
                </tr>
            );
        });
    }

    const handleUploadFiles = async () => {
        setLoadingFileUpload(true)
        if (errorInFile === true) {
            toast.error("First fill the required fields")
            setLoadingFileUpload(false)
            return
        }
        try {


        } catch (error) {
            console.log("error is:", error)
            toast.error("Error Uploading File")
        } finally {

        }
    }



    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <ToastContainer limit={1} />
                            <div className="card">
                                <div className="">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            Legacy Securities Bulk Upload
                                            <Dropdown className="float-right transaction_dropdown">
                                                <Dropdown.Toggle variant="dark" id="dropdown-basic">
                                                    Download Samples
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu
                                                    style={{
                                                        maxHeight: "300px",
                                                        overflow: "auto",
                                                        backgroundColor: theme == "dark" ? "rgb(30, 30, 47)" : ""
                                                    }}
                                                >
                                                    {downloadSampleArr?.map((item, index) => (
                                                        <Dropdown.Item
                                                            style={{
                                                                color: "#9a9a9a"
                                                            }}
                                                            key={index}
                                                            href={`${env.REACT_APP_SAMPLE_URL}TXN/${item?.path}`}
                                                            download
                                                        >
                                                            {(item?.label)?.toUpperCase()}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        <Row className="mb-3">
                                            <Col md="6">
                                                <label>Choose File </label>
                                                <div
                                                    className="form-control multi-input ml-auto"
                                                    style={{
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => myRef1?.current?.click()}
                                                >
                                                    <div className="form-group mb-0">
                                                        <div className="fom-control ml-2">
                                                            {fileName === "" ? "Upload File" : fileName}
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            ref={myRef1}
                                                            style={{ display: "none" }}
                                                            multiple={false}
                                                            onChange={(e) => {
                                                                upload(e)
                                                            }}
                                                        />
                                                        {fileError ? (
                                                            <p className="error-labels error-message2">
                                                                {fileError}
                                                            </p>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                </div>
                                                {fileUploadingFlag && (
                                                    <img src="assets/loader.svg" width="50" />
                                                )}
                                            </Col>
                                        </Row>
                                        {
                                            fileData?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table
                                                        className="table mt-3 ">
                                                        <thead>
                                                            {
                                                                Object.keys(fileData?.[0])?.map((heading) => {
                                                                    return (
                                                                        <th
                                                                            style={{
                                                                                paddingLeft: "7px",
                                                                                paddingRight: "7px",
                                                                                border: "1px solid"
                                                                            }}
                                                                            className="text-nowrap"
                                                                        >
                                                                            {heading}
                                                                        </th>
                                                                    )
                                                                })}

                                                        </thead>
                                                        <tbody>{renderTable()}</tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                fileName ?
                                                    <Row className="d-flex justify-content-center my-3">
                                                        <i
                                                            className="fa fa-spinner fa-spin fa-3x"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </Row> : null
                                            )
                                        }
                                        Total Rows:{" "}
                                        <span className="text-primary mt-3">{fileDataCount} </span>
                                        <div className="mt-4">
                                            <button
                                                className="btn btn-primary"
                                                disabled={Boolean(loading) || fileData?.length < 1 || loadingFileUpload}
                                                onClick={() => handleUploadFiles()}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border login-txt spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        <span className="login-txt"> Loading...</span>
                                                    </>
                                                ) : (
                                                    <span>Upload</span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default LegacySecuritiesUploader;
